import { z } from "zod";

import { ScrapeRefundOutcome } from "@signalist/shared-types";

/** Lifecycle of one scraping delivery — mirrors the API's ScrapeRequestStatus (PREC-3091). */
export enum ScrapeRequestStatus {
	REQUESTED = "REQUESTED",
	DELIVERED = "DELIVERED",
	CANCELLED = "CANCELLED",
}

/**
 * One scraping delivery of a source: the initial request plus every re-scrape ordered afterwards.
 * The newest DELIVERED one owns the "Latest" file; an open REQUESTED one is shown as "Processing".
 */
export const ScrapeRequestSchema = z.object({
	id: z.number(),
	customEventId: z.number(),
	listId: z.number().optional().nullable(),
	status: z.nativeEnum(ScrapeRequestStatus),
	isInitial: z.boolean(),
	csvEnrichmentId: z.number().optional().nullable(),
	requestedAt: z.string().optional().nullable(),
	deliveredAt: z.string().optional().nullable(),
	requestedByName: z.string().optional().nullable(),
	/** Only on the answer to a cancel: what it gave back, 0 when nothing was charged (PREC-4456). */
	refundedCredits: z.number().optional().nullable(),
	/** Only on the answer to a cancel: what it did about the credit (PREC-4456). */
	refundOutcome: z.nativeEnum(ScrapeRefundOutcome).optional().nullable(),
	/** Only on a delivery: the open request had been cancelled meanwhile (PREC-4456). */
	cancelledMeanwhileRequestId: z.number().optional().nullable(),
});

export const ScrapeRequestsSchema = z.array(ScrapeRequestSchema);

export type ScrapeRequest = z.infer<typeof ScrapeRequestSchema>;
